import React from "react";

export const defaultRequestSubmissionContext = {};

export const RequestSubmissionContext = React.createContext(defaultRequestSubmissionContext);
